import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  OnChanges,
  OnInit,
  output,
  SimpleChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutside } from '@shared/directives/click-outside';

@Component({
  selector: 'app-multi-select',
  imports: [
    TranslateModule,
    ClickOutside,
  ],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectComponent implements OnInit, OnChanges {
  title = input<string>('Select option');
  placeholder = input<string>('Select option');
  options = input.required<any[]>();
  isAllSelected = input<string>('');
  preselectedValues = input<string[]>([]);

  readonly cd: ChangeDetectorRef = inject(ChangeDetectorRef);

  itemsChanged = output<string[]>();
  isDropdownOpen = false;
  selectedItems: string[] = [];
  dropdownOptions: string[] = [];

  ngOnInit(): void {
    this.setupDropdownValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && !changes['options']?.firstChange) {
      this.selectedItems = [];
      this.dropdownOptions = [];
      if (this.isAllSelected().length) {
        this.selectedItems.push(this.isAllSelected());
      }
      this.setupDropdownValues();
    }
  }

  setupDropdownValues(): void {
    this.dropdownOptions = [...this.options()];
    if (this.preselectedValues() && this.preselectedValues().length) {
      this.selectedItems = [...this.preselectedValues()];
      this.itemsChanged.emit(this.selectedItems);
    } else if (this.isAllSelected() && this.isAllSelected()?.length) {
      if (!this.selectedItems.includes(this.isAllSelected()?.toString())) {
        this.selectedItems.push(this.isAllSelected()?.toString());
      }
      this.itemsChanged.emit(this.selectedItems);
    }
    this.cd.markForCheck();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  clickOutside() {
    this.isDropdownOpen = false;
  }

  selectItem(item: string) {
    if (this.selectedItems.indexOf(item) === -1) {
      // When item is added if 'All' option was selected we have to remove it from array
      if (this.selectedItems.includes(this.isAllSelected())) {
        this.removeItem(this.isAllSelected(), true);
      }

      this.selectedItems.push(item);
      this.itemsChanged.emit(this.selectedItems);

    }
    this.toggleDropdown();
    this.cd.markForCheck();
  }


  removeItem(item: string, canBeEmpty: boolean = false): void {
    if (this.selectedItems.indexOf(item) !== -1) {
      this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
      this.itemsChanged.emit(this.selectedItems);
    }

    // If all items removed - set value as All by default
    if (!this.selectedItems.length && this.isAllSelected().length && !canBeEmpty) {
      this.selectedItems.push(this.isAllSelected());
      this.itemsChanged.emit(this.selectedItems);
    }
  }

}
